export default __webpack_public_path__ + "static/media/dazn.99d0d2ce.png";